import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../models/response-api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Stripe } from '@stripe/stripe-js';
import { CrudService } from '../crud-service/crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StripeService extends CrudService<
  ApiResponse<any>,
  number
> {
  stripePromise!: Promise<Stripe>;

  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  // private loadStripe(): Promise<Stripe> {
  //   return (window as any)?.Stripe(environment.stripeKey);
  // }

  redirectToCheckout(body: any): Observable<any> {
    return this._http.post(this._base + '/Payment/checkout', body);
  }

  redirectToCheckoutChangeOffer(body: any): Observable<any> {
    return this._http.post(this._base + '/Payment/changeOffer', body);
  }
  redirectToCheckoutAddCard(body: any): Observable<any> {
    return this._http.post(this._base + '/Payment/updatePaymentMethod', body);
  }

  getListAbonnement(data?: {
    per_page?: number;
    page?: number;
    search? : string;
  }) {
   let page=1
   if(data?.page){
    page=data?.page+1
   }
   let url = `${this._base}/AbonnementCompany/getListAbonnementActuelByESN?per_page=${data?.per_page}&page=${page}`;
   if (data?.search) {
      url = url?.concat(`&search=${data?.search}`);
    }
    return this._http.get<ApiResponse<any>>(url);
  }

  getListOffer() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Offer/getAllOffer`
    );
  }
  getListPermissions() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Permission/getAll`
    );
  }
  getListOfCard(stripe_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Payment/fetchPaymentMethods/${stripe_id}`
    );
  }

  getListCard(customer_id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Payment/listCustomerCards?customer_id=${customer_id}`
    );
  }

  getAllDetailsOfAbonnement(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/AbonnementCompany/AbonnementDetailsByESN?id=${id}`
    );
  }
  getAllDetailsOfInvoice(data: any) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Payment/invoices?subscription_id=${data?.invoiceId}&per_page=${data?.per_page}&page=${data?.page}`
    );
  }

  searchAbonnement(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/AbonnementCompany/searchInListAbonnementActuelByESN`,
      data
    );
  }
  searchInvoice(data: any, idEsn: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Payment/searchIninvoicesStripe?subscription_id=${idEsn}`,
      data
    );
  }

  cancelSubscription(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/AbonnementCompany/CancelSubscription`,
      data
    );
  }

  exportInvoice(file: any, data: any) {
    return this._http.get(
      this._base + `/Payment/invoiceDownload?invoice_id=${data}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }
  deleteCard(id: any): Observable<any> {
    const url = `${this._base}/Payment/deletePaymentMethod?payment_method_id=${id}`;
    return this._http.delete(url);
  }
  searchCards(data: any, idEsn: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Payment/searchInPaymentMethods?customerId=${idEsn}`,
      data
    );
  }
  getActiveSubscriptionPlan(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/Offer/active-plan`);
  }
  archive(data: any): Observable<any> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/Offer/archive`, data);

  }
  redirectToCheckoutAddCardClient(): Observable<any> {
    return this._http.get(`${this._base}/Company/generateStripeLink`)
  }
}
